// Tickable Mail: campaigns, contacts (Bezoekers) and segments (nl)
export default {
  "mail_contacts_growth_question": "Aan wie mag je nieuwsmail sturen?",
  "mail_segment_narrow": "Alleen naar bepaalde mensen",
  // Segment
  "mail_segment_events": "Kwam naar",
  "mail_segment_events_any": "Alle activiteiten",
  "mail_segment_ticket_types": "Met tickettype",
  "mail_segment_ticket_types_any": "Alle tickettypes",
  "mail_segment_ticket_types_pick_event": "Kies eerst een activiteit",
  "mail_segment_period": "Bezocht tussen",
  "mail_segment_period_any": "Altijd",
  "mail_segment_period_help": "De datum van het bezoek, dus van het tijdslot.",
  "mail_segment_exclude_events": "Nog geen ticket voor",
  "mail_segment_exclude_events_none": "Maakt niet uit",
  "mail_segment_exclude_events_help": "Bijvoorbeeld: kwam vorig jaar (hierboven), heeft dit jaar nog geen ticket (hier).",
  "mail_segment_min_orders": "Minstens zo vaak gekocht",
  "mail_segment_min_orders_any": "Maakt niet uit",
  "mail_segment_min_orders_help": "Bestellingen bij jouw organisatie, over al je activiteiten. Voor je vaste bezoekers.",
  "mail_segment_presets": "Snel kiezen:",
  "mail_segment_preset_everyone": "Iedereen",
  "mail_segment_preset_regulars": "Vaste bezoekers (3+)",
  "mail_segment_preset_lapsed": "Vorig jaar wel, nu nog niet",
  "mail_segment_preset_lapsed_help": "Kies bij \"Kwam naar\" de activiteit van vorig jaar, en bij \"Nog geen ticket voor\" die van dit jaar.",
  "mail_segment_preset_no_shows": "Wel gekocht, niet gekomen",
  "mail_segment_attendance": "Aanwezig",
  "mail_segment_attendance_any": "Maakt niet uit",
  "mail_segment_attendance_came": "Was er (gescand)",
  "mail_segment_attendance_no_show": "Kwam niet",
  "mail_segment_tags": "Tags",
  "mail_segment_tags_any": "Alle tags",
  "mail_segment_tags_none": "Nog geen tags",
  "mail_segment_tags_mode_any": "Een van deze",
  "mail_segment_tags_mode_all": "Allemaal",
  "mail_segment_languages": "Taal",
  "mail_segment_languages_any": "Alle talen",
  "mail_segment_count_nobody": "Niemand past bij deze filters.",
  "mail_segment_count_reachable": "Niemand met toestemming | 1 ontvanger | {n} ontvangers",
  "mail_segment_count_skipped": "{n} zonder toestemming niet meegenomen",

  // Campaigns list
  "mail_campaign_intro": "Je nieuwsbrieven en je berichten aan bezoekers. Een bericht aan bezoekers begin je op de pagina van je activiteit.",
  "mail_campaign_new": "Nieuwe nieuwsbrief",
  "mail_campaign_default_name": "Nieuwsbrief {date}",
  "mail_campaign_create_failed": "Nieuwsbrief aanmaken lukte niet",
  "mail_campaign_load_failed": "Nieuwsbrieven laden lukte niet",
  "mail_campaign_quota_sent": "{sent} van {limit} nieuwsmails deze maand",
  "mail_campaign_quota_contacts": "{contacts} van {limit} bezoekers met toestemming",
  "mail_campaign_quota_contacts_over": "Je hebt meer dan {limit} bezoekers met toestemming. Daardoor kun je nu geen nieuwsbrieven versturen. Neem contact met ons op, dan zoeken we het samen uit.",
  "mail_campaign_quota_month_full": "Je nieuwsmails voor deze maand zijn op. Volgende maand kun je weer.",
  "mail_campaign_empty_title": "Nog geen nieuwsbrieven",
  "mail_campaign_empty": "Maak je eerste nieuwsbrief: kies wie hem krijgt, kies een mail en stuur eerst een test naar jezelf.",
  "mail_campaign_empty_no_contacts": "Je hebt nog niemand met toestemming, dus er is nog niemand om te mailen.",
  "mail_campaign_empty_contacts_link": "Zo groeit je lijst",
  "mail_campaign_name": "Naam",
  "mail_campaign_recipients": "Ontvangers",
  "mail_campaign_edited": "bewerkt {when}",
  "mail_campaign_status_draft": "Concept",
  "mail_campaign_status_scheduled": "Ingepland",
  "mail_campaign_status_sending": "Wordt verstuurd",
  "mail_campaign_status_sent": "Verstuurd",
  "mail_campaign_status_cancelled": "Geannuleerd",

  // Wizard
  "mail_campaign_not_found": "Deze mail bestaat niet (meer).",
  "mail_campaign_saving": "Opslaan…",
  "mail_campaign_saved": "Opgeslagen",
  "mail_campaign_save_failed": "Opslaan lukte niet",
  "mail_campaign_step_recipients": "Ontvangers",
  "mail_campaign_step_content": "Inhoud",
  "mail_campaign_step_send": "Versturen",
  "mail_campaign_recipients_intro": "Zonder filters gaat hij naar iedereen met toestemming. Wie geen toestemming gaf, krijgt hem nooit.",
  "mail_campaign_pick_mail": "Welke mail?",
  "mail_campaign_no_templates": "Je hebt nog geen nieuwsmail. Begin met een van de voorbeelden hieronder.",
  "mail_campaign_new_mail_from": "Nieuwe mail op basis van:",
  "mail_campaign_template_failed": "Mail aanmaken lukte niet",
  "mail_campaign_preview": "Zo ziet hij eruit",
  "mail_campaign_preview_language": "Taal van de preview",
  "mail_campaign_preview_failed": "De preview laden lukte niet. Probeer het zo nog eens.",
  "mail_campaign_edit_mail": "Bewerken",
  "mail_campaign_mail": "Mail",
  "mail_campaign_no_send_right": "Je kunt deze nieuwsbrief voorbereiden, maar versturen mag alleen iemand met het recht om nieuwsbrieven te versturen.",
  "mail_campaign_postal_missing": "In elke nieuwsmail moet je postadres staan, dat is wettelijk verplicht. Je hebt het nog niet ingevuld.",
  "mail_campaign_postal_link": "Postadres invullen",
  "mail_campaign_summary": "Wat er gaat gebeuren",
  "mail_campaign_summary_line": "Niemand krijgt ‘{subject}’. | 1 persoon krijgt ‘{subject}’. | {n} mensen krijgen ‘{subject}’.",
  "mail_campaign_summary_no_recipients": "Er is nog niemand met toestemming die bij je filters past.",
  "mail_campaign_summary_no_mail": "Kies eerst een mail bij Inhoud.",
  "mail_campaign_quota_after": "Daarna heb je deze maand {used} van {limit} nieuwsmails gebruikt.",
  "mail_campaign_quota_would_exceed": "Dat past niet: je hebt deze maand nog {left} van {limit} nieuwsmails. Maak je groep kleiner of wacht tot volgende maand.",
  "mail_campaign_test_title": "Eerst een testmail",
  "mail_campaign_test_intro": "Je krijgt hem eerst zelf, zo zie je hoe hij aankomt. Pas je daarna iets aan? Dan stuur je opnieuw een test.",
  "mail_campaign_test_send": "Stuur testmail naar mij",
  "mail_campaign_test_again": "Nog een test sturen",
  "mail_campaign_test_sent": "Test gestuurd naar {to}",
  "mail_campaign_test_failed": "Testmail sturen lukte niet",
  "mail_campaign_when_title": "Wanneer?",
  "mail_campaign_mode_now": "Nu",
  "mail_campaign_mode_later": "Later",
  "mail_campaign_schedule_at": "Versturen op",
  "mail_campaign_send_now": "Nu versturen",
  "mail_campaign_schedule": "Inplannen",
  "mail_campaign_send_needs_test": "Stuur eerst een testmail.",
  "mail_campaign_confirm_now_title": "Nu versturen?",
  "mail_campaign_confirm_now": "Er gaat niemand iets krijgen. | 1 persoon krijgt deze mail meteen. Als hij eenmaal verstuurd is, kun je dat niet meer terugdraaien. | {n} mensen krijgen deze mail meteen. Als hij eenmaal verstuurd is, kun je dat niet meer terugdraaien.",
  "mail_campaign_confirm_later_title": "Inplannen?",
  "mail_campaign_confirm_later": "Er gaat niemand iets krijgen. | 1 persoon krijgt deze mail op {when}. Tot dan kun je annuleren. | {n} mensen krijgen deze mail op {when}. Tot dan kun je annuleren.",
  "mail_campaign_recipients_count": "Geen ontvangers | 1 ontvanger | {n} ontvangers",
  "mail_campaign_error_not_allowed": "Je hebt niet het recht om nieuwsbrieven te versturen.",
  "mail_campaign_error_mail_campaign_not_draft": "Deze nieuwsbrief is al ingepland of verstuurd.",
  "mail_campaign_error_mail_not_enabled": "Nieuwsbrieven werken pas als je je eigen mails hebt aangezet.",
  "mail_campaign_error_mail_campaign_without_template": "Kies eerst een mail bij Inhoud.",
  "mail_campaign_error_mail_postal_address_missing": "In elke nieuwsmail moet je postadres staan, en dat heb je nog niet ingevuld.",
  "mail_campaign_error_mail_contact_limit": "Je hebt meer mensen met toestemming dan je gratis kunt mailen. Vraag bovenaan een hogere grens aan.",
  "mail_campaign_error_mail_campaign_no_recipients": "Er is niemand met toestemming die bij je filters past.",
  "mail_campaign_error_mail_monthly_limit": "Hiermee kom je boven je maximum aan nieuwsmails voor deze maand. Maak je groep kleiner of wacht tot volgende maand.",
  "mail_campaign_error_unknown": "Dat lukte niet. Probeer het nog eens, en werkt het dan nog niet, laat het ons weten.",
  "mail_campaign_error_contacts_link": "Naar je bezoekers",
  "mail_campaign_error_already_sending": "Er zijn al mails verstuurd, dus annuleren kan niet meer.",

  // After scheduling
  "mail_campaign_scheduled_for": "Ingepland voor",
  "mail_campaign_sent_at": "Verstuurd op",
  "mail_campaign_progress": "Voortgang",
  "mail_campaign_progress_line": "{done} van {total} afgehandeld",
  "mail_campaign_cancel": "Nieuwsbrief annuleren",
  "mail_campaign_cancel_help": "Kan zolang er nog niks is verstuurd. De nieuwsbrief wordt dan weer een concept.",
  "mail_campaign_cancel_title": "Nieuwsbrief annuleren?",
  "mail_campaign_cancel_confirm": "Er gaat niks de deur uit en de nieuwsbrief wordt weer een concept, zodat je hem kunt aanpassen.",
  "mail_campaign_cancel_failed": "Annuleren lukte niet",

  // Contacts (Bezoekers)
  "mail_contacts_stats_total": "Nog geen bezoekers | 1 bezoeker | {n} bezoekers",
  "mail_contacts_stats_consent": "{n} met toestemming",
  "mail_contacts_stats_regulars": "1 vaste bezoeker | {n} vaste bezoekers",
  "mail_contacts_stats_unsubscribed": "{n} afgemeld",
  "mail_contacts_stats_broken": "{n} onbereikbaar",
  "mail_contacts_growth": "Nieuwsmail mag je alleen sturen aan mensen die daar zelf voor kozen. Je lijst groeit als kopers het vinkje in je shop aanzetten, als mensen zich aanmelden via je formulier, of als je een bestaande lijst importeert. Kopers van vóór het vinkje krijgen alleen mail over hun eigen bestelling.",
  "mail_contacts_growth_link": "Vinkje in je shop instellen",
  "mail_contacts_import": "Importeren",
  "mail_contacts_search": "Zoek op naam of e-mailadres",
  "mail_contacts_filter_consent_yes": "Met toestemming",
  "mail_contacts_filter_consent_no": "Zonder toestemming",
  "mail_contacts_filter_tags": "Activiteit of tag",
  "mail_contacts_filter_orders": "Bestellingen",
  "mail_contacts_filter_orders_returning": "2 keer of vaker",
  "mail_contacts_filter_orders_once": "1 keer besteld",
  "mail_contacts_filter_source": "Herkomst",
  "mail_contacts_load_failed": "Bezoekers laden lukte niet",
  "mail_contacts_empty_title": "Nog geen bezoekers",
  "mail_contacts_empty": "Zodra iemand iets koopt of zich aanmeldt, staat die hier. Heb je al een lijst in Mailchimp, Brevo of Laposta? Importeer hem, dan kun je meteen verder.",
  "mail_contacts_empty_filtered": "Niemand gevonden met deze filters.",
  "mail_contacts_contact": "Bezoeker",
  "mail_contacts_consent": "Toestemming",
  "mail_contacts_consent_none": "Geen",
  "mail_contacts_consent_given": "Gegeven op {date}, {source}.",
  "mail_contacts_consent_none_detail": "Geen toestemming voor nieuwsmail. Deze persoon krijgt alleen mail over de eigen bestelling.",
  "mail_contacts_source_checkout": "via het vinkje in de shop",
  "mail_contacts_source_import": "via een import",
  "mail_contacts_source_signup_form": "via het aanmeldformulier",
  "mail_contacts_source_waitlist": "via de wachtlijst",
  "mail_contacts_source_unknown": "herkomst onbekend",
  "mail_contacts_tags": "Tags",
  "mail_contacts_tag_add": "Toevoegen",
  "mail_contacts_tag_add_placeholder": "Nieuwe tag",
  "mail_contacts_tag_remove": "Tag {tag} weghalen",
  "mail_contacts_last_order": "Laatste bestelling",
  "mail_contacts_with_you": "Bij jou",
  "mail_contacts_orders_n": "{n}× besteld",
  "mail_contacts_orders_none": "Nog niks besteld",
  "mail_contacts_activities": "Activiteiten en tags",
  "mail_contacts_event_next": "{title}, komt op {date}",
  "mail_contacts_more": "+{n}",
  "mail_contacts_newsletter_yes": "Ja",
  "mail_contacts_newsletter_no": "Nee",
  "mail_contacts_tier_regular": "Vaste bezoeker",
  "mail_contacts_tier_regular_title": "Bestelde {n} keer of vaker bij jou",
  "mail_contacts_tier_superfan": "Superfan",
  "mail_contacts_tier_superfan_title": "Bestelde {n} keer of vaker bij jou",
  "mail_contacts_status_unsubscribed": "Afgemeld",
  "mail_contacts_status_bounced": "Werkt niet",
  "mail_contacts_status_complained": "Spam gemeld",
  "mail_contacts_status_unsubscribed_on": "Afgemeld op {date}",
  "mail_contacts_status_bounced_on": "Dit adres werkt niet (sinds {date})",
  "mail_contacts_status_complained_on": "Heeft een mail als spam gemeld op {date}",
  "mail_contacts_save_failed": "Opslaan lukte niet",
  "mail_contacts_unsubscribe": "Afmelden",
  "mail_contacts_unsubscribe_confirm": "{email} krijgt dan geen nieuwsmail meer. Dit kun je niet zelf terugdraaien: alleen de persoon zelf kan opnieuw toestemming geven.",
  "mail_contacts_delete_help": "Voor als iemand vraagt om de gegevens te verwijderen (AVG).",
  "mail_contacts_delete_title": "Bezoeker verwijderen?",
  "mail_contacts_delete_confirm": "{email} verdwijnt uit je bezoekers, met tags en toestemming. Bestellingen blijven gewoon bestaan. Koopt deze persoon later weer iets, dan komt hij opnieuw in de lijst.",
  "mail_contacts_delete_failed": "Verwijderen lukte niet",

  // Import
  "mail_contacts_import_title": "Bezoekers importeren",
  "mail_contacts_import_intro": "Kom je van Mailchimp, Brevo, Laposta of een ander programma? Exporteer je lijst daar als CSV of Excel en upload hem hier. Daarna geef je aan welke kolom wat is.",
  "mail_contacts_import_choose": "Kies een bestand",
  "mail_contacts_import_formats": "CSV of Excel (.xlsx)",
  "mail_contacts_import_empty": "Dit bestand is leeg.",
  "mail_contacts_import_parse_error": "Dit bestand konden we niet lezen. Is het een CSV of .xlsx?",
  "mail_contacts_import_file_rows": "{file}: {n} rijen. Dit zijn de eerste:",
  "mail_contacts_import_field_email": "E-mailadres",
  "mail_contacts_import_field_name": "Naam of voornaam",
  "mail_contacts_import_field_last_name": "Achternaam",
  "mail_contacts_import_field_language": "Taal",
  "mail_contacts_import_field_tags": "Tags",
  "mail_contacts_import_field_status": "Status",
  "mail_contacts_import_pick_column": "Kies een kolom",
  "mail_contacts_import_not_in_file": "Niet in dit bestand",
  "mail_contacts_import_status_values": "Welke statussen betekenen afgemeld?",
  "mail_contacts_import_status_help": "Wie zich bij je oude programma afmeldde of wiens adres niet werkte (cleaned), komt hier binnen als afgemeld en krijgt geen nieuwsmail.",
  "mail_contacts_import_status_empty": "(leeg)",
  "mail_contacts_import_found": "{n} bezoekers",
  "mail_contacts_import_found_unsub": "{n} afgemeld",
  "mail_contacts_import_found_invalid": "{n} zonder geldig e-mailadres, die slaan we over",
  "mail_contacts_import_found_duplicates": "{n} dubbel, samengevoegd",
  "mail_contacts_import_tags": "Tags voor deze import",
  "mail_contacts_import_tags_placeholder": "Typ een tag en druk op Enter",
  "mail_contacts_import_tags_help": "Iedereen uit dit bestand krijgt deze tags. Handig om ze later terug te vinden of apart te mailen.",
  "mail_contacts_import_statement": "Hoe gaven deze mensen toestemming?",
  "mail_contacts_import_statement_why": "Je mag alleen mensen mailen die daar zelf voor kozen. We bewaren wat je hier schrijft als bewijs, voor als iemand vraagt waarom hij mail van je krijgt.",
  "mail_contacts_import_statement_placeholder": "Bijvoorbeeld: aangemeld voor onze nieuwsbrief via het formulier op onze website, sinds 2021 bijgehouden in Mailchimp.",
  "mail_contacts_import_confirm": "Deze mensen hebben toestemming gegeven om mail van ons te krijgen.",
  "mail_contacts_import_over_limit": "Na deze import heb je mogelijk {n} bezoekers met toestemming. Gratis kun je nieuwsbrieven sturen tot {limit} bezoekers; daarboven kan versturen niet meer tot je lijst kleiner is of je een groter pakket hebt.",
  "mail_contacts_import_run": "{n} bezoekers importeren",
  "mail_contacts_import_running": "Bezig met importeren. Laat dit venster even open.",
  "mail_contacts_import_done": "Klaar!",
  "mail_contacts_import_partial": "De import is halverwege gestopt",
  "mail_contacts_import_failed": "Importeren lukte niet",
  "mail_contacts_import_failed_detail": "Wat hierboven staat is wel binnen. Foutmelding: {message}",
  "mail_contacts_import_count_added": "Nieuw",
  "mail_contacts_import_count_updated": "Bijgewerkt",
  "mail_contacts_import_count_unchanged": "Al bekend, niks veranderd",
  "mail_contacts_import_count_unsubscribed": "Als afgemeld",
  "mail_contacts_import_count_invalid": "Overgeslagen",
  "mail_contacts_import_undo_hint": "Toch niet goed? Hieronder maak je hem ongedaan.",
  "mail_contacts_imports_title": "Eerdere imports",
  "mail_contacts_imports_no_name": "Import",
  "mail_contacts_imports_counts": "{added} nieuw, {updated} bijgewerkt",
  "mail_contacts_imports_undone": "ongedaan gemaakt: {n} verwijderd, {kept} bewaard omdat ze al mail kregen",
  "mail_contacts_imports_undo": "Ongedaan maken",
  "mail_contacts_imports_undo_title": "Import ongedaan maken?",
  "mail_contacts_imports_undo_confirm": "De bezoekers die met deze import nieuw binnenkwamen worden verwijderd. Wie al een mail van je kreeg, blijft staan. Mensen die al in je lijst stonden houden alles, ook de tags en toestemming die de import toevoegde.",
  "mail_contacts_imports_undo_failed": "Ongedaan maken lukte niet",

  // Newsletter and message to visitors (phase 2b)
  "mail_campaign_error_mail_service_needs_event": "Een bericht aan bezoekers hoort bij een activiteit. Begin het op de pagina van je activiteit.",
  "mail_campaign_error_mail_template_locked": "Deze mail ligt vast, want hij is al ingepland of verstuurd.",
  "mail_campaign_kind_news": "Nieuwsbrief",
  "mail_campaign_kind_service": "Bericht aan bezoekers",
  "mail_campaign_name_internal": "Naam voor jezelf",
  "mail_campaign_pick_other": "Andere mail kiezen",
  "mail_campaign_from_design": "Of begin met een eigen ontwerp:",
  "mail_campaign_design_copied": "Je krijgt een eigen kopie, je ontwerp zelf blijft zoals het is.",
  "mail_campaign_pick_keep": "Toch de huidige houden",
  "mail_campaign_replace_title": "Andere mail kiezen?",
  "mail_campaign_replace_confirm": "Wat je in deze mail hebt geschreven, wordt vervangen.",
  "mail_campaign_replace": "Vervangen",
  "mail_campaign_translation_missing": "Nog niet alles is vertaald ({langs}). Wat ontbreekt, komt in je eerste taal.",
  "mail_campaign_translation_fix": "Aanvullen",
  "mail_campaign_postal_label": "Je postadres",
  "mail_campaign_postal_why": "Dat moet in elke nieuwsbrief staan. Je vult het één keer in.",
  "mail_campaign_postal_save": "Opslaan",
  "mail_campaign_test_colleague": "Test naar collega",
  "mail_campaign_test_colleague_pick": "Kies een collega",
  "mail_campaign_test_colleague_send": "Sturen",
  "mail_campaign_test_not_team": "Dat adres hoort niet bij je team.",
  "mail_campaign_later": "Later versturen",
  "mail_campaign_now_instead": "Toch nu versturen",
  "mail_campaign_tz_nl": "Nederlandse tijd",
  "mail_campaign_outcome": "Hoe het ging",
  "mail_campaign_outcome_cell": "{n} van {total} aangekomen",
  "mail_campaign_done": "Klaar, maar niemand heeft je nieuwsbrief gekregen. | Klaar: 1 persoon heeft je nieuwsbrief gekregen. | Klaar: {n} mensen hebben je nieuwsbrief gekregen.",
  "mail_campaign_done_failed": "Alle adressen werkten. | 1 adres werkte niet. | {n} adressen werkten niet.",
  "mail_campaign_blocked_help": "Deze hielden we tegen, omdat de tekst op misbruik leek. Klopt dat niet? Mail even naar",
  "mail_campaign_delete": "Verwijderen",
  "mail_campaign_delete_title": "Concept verwijderen?",
  "mail_campaign_delete_message": "‘{name}’ is nog niet verstuurd en verdwijnt helemaal, ook de mail die erbij hoort.",
  "mail_campaign_delete_failed": "Verwijderen lukte niet",
  "mail_campaign_copy": "Kopiëren",
  "mail_campaign_copy_name": "Kopie van {name}",
  "mail_limit_line": "Je hebt {contacts} mensen met toestemming; gratis mail je tot {limit}.",
  "mail_limit_close_why": "Wil je meer mensen mailen? Dan kijken we eerst naar je lijst, zodat je mails in de inbox blijven landen.",
  "mail_limit_reached_why": "Je nieuwsbrief kan nu niet weg. Vraag een hogere grens aan, dan kijken we naar je lijst en zetten we hem hoger.",
  "mail_limit_request": "Grens laten ophogen",
  "mail_limit_requested": "Aangevraagd op {date}. We laten het je weten.",
  "mail_limit_request_failed": "Aanvragen lukte niet",
  "mail_service_action": "Bericht aan bezoekers",
  "mail_service_default_name": "Bericht over {event}",
  "mail_service_classic_title": "Eerst je eigen mails aanzetten",
  "mail_service_classic_text": "Een bericht aan je bezoekers stuur je met je eigen mails. Aanzetten is zo gedaan, en er verandert niks tot jij iets aanzet.",
  "mail_service_classic_action": "Bekijk hoe",
  "mail_service_recipients_upcoming": "Iedereen met een ticket voor {event}, voor de tijdsloten die nog komen.",
  "mail_service_recipients_all": "Iedereen met een ticket voor {event}, ook voor tijdsloten die al voorbij zijn.",
  "mail_service_count_nobody": "Er heeft nog niemand een geldig ticket voor deze tijdsloten.",
  "mail_service_count_tickets": "geen tickets | 1 ticket | {n} tickets",
  "mail_service_count_addresses": "geen adressen | 1 adres | {n} adressen",
  "mail_service_count_bounced": "geen | 1 adres werkt niet | {n} adressen werken niet",
  "mail_service_count_no_email": "geen | 1 bestelling zonder e-mailadres | {n} bestellingen zonder e-mailadres",
  "mail_service_order_no_name": "Bestelling zonder naam",
  "mail_service_no_email_more": "en nog {n}",
  "mail_service_pick_slots": "Tijdsloten kiezen",
  "mail_service_slots": "Welke tijdsloten?",
  "mail_service_slots_all_upcoming": "Alle tijdsloten die nog komen",
  "mail_service_slots_all": "Alle tijdsloten",
  "mail_service_slots_include_past": "Ook tijdsloten die al voorbij zijn",
  "mail_service_summary_line": "Niemand krijgt ‘{subject}’. | 1 bezoeker krijgt ‘{subject}’. | {n} bezoekers krijgen ‘{subject}’.",
  "mail_service_summary_no_recipients": "Er is nog niemand met een ticket die dit bericht kan krijgen.",
  "mail_service_no_send_right": "Je kunt dit bericht voorbereiden, maar versturen mag alleen iemand met het recht om mails te versturen.",
  "mail_service_reassure": "Geen toestemming nodig: dit gaat over hun ticket. Houd het bij de wijziging.",
  "mail_service_test_intro": "Even zien hoe hij aankomt? Stuur hem eerst naar jezelf.",
  "mail_service_confirm_now": "Niemand krijgt dit bericht. | 1 bezoeker krijgt dit bericht meteen. Terughalen kan daarna niet meer. | {n} bezoekers krijgen dit bericht meteen. Terughalen kan daarna niet meer.",
  "mail_service_confirm_later": "Niemand krijgt dit bericht. | 1 bezoeker krijgt dit bericht op {when}. Tot dan kun je annuleren. | {n} bezoekers krijgen dit bericht op {when}. Tot dan kun je annuleren.",
  "mail_service_cancel": "Bericht annuleren",
  "mail_service_cancel_help": "Kan zolang er nog niks is verstuurd. Het bericht wordt dan weer een concept.",
  "mail_service_cancel_title": "Bericht annuleren?",
  "mail_service_cancel_confirm": "Er gaat niks de deur uit en het bericht wordt weer een concept, zodat je het kunt aanpassen.",
  "mail_service_done": "Naar niemand verstuurd. | Verstuurd naar 1 bezoeker van {target}. | Verstuurd naar {n} bezoekers van {target}.",
  "mail_service_done_replies": "Antwoorden komen binnen bij",
  "mail_segment_preset_new_this_year": "Nieuw dit jaar",
  "mail_segment_preset_not_seen_year": "Al een jaar niet gezien",
  "mail_campaign_kind_invitation": "Uitnodiging",
  "mail_invitation_default_name": "Uitnodiging {discount}",
  "mail_invitation_codes_of": "Met codes van {discount}",
  "mail_invitation_who": "Wie nodig je uit?",
  "mail_invitation_mode_consent": "Met toestemming",
  "mail_invitation_mode_group": "Een groep",
  "mail_invitation_mode_list": "Eigen lijst",
  "mail_invitation_consent_line": "Iedereen die toestemming gaf om gemaild te worden.",
  "mail_invitation_reminder_recipients": "Wie de uitnodiging kreeg en nog niks kocht. Ze krijgen dezelfde code nog een keer.",
  "mail_invitation_list_label": "Plak je lijst, één persoon per regel",
  "mail_invitation_list_placeholder": "Jan Jansen <jan{'@'}voorbeeld.nl>\nsanne{'@'}voorbeeld.nl",
  "mail_invitation_list_save": "Lijst opslaan",
  "mail_invitation_list_csv": "CSV kiezen",
  "mail_invitation_list_saved": "Niemand op je lijst | 1 persoon op je lijst | {n} mensen op je lijst",
  "mail_invitation_list_new": "{n} nieuw in je contacten",
  "mail_invitation_list_unreachable": "geen | 1 krijgt niks: afgemeld of adres werkt niet | {n} krijgen niks: afgemeld of adres werkt niet",
  "mail_invitation_list_invalid": "Geen | Dit adres klopt niet en laten we weg: {list} | Deze adressen kloppen niet en laten we weg: {list}",
  "mail_invitation_list_confirm": "Deze mensen verwachten dit van je (leden, sponsors, genodigden)",
  "mail_invitation_unsubscribe_line": "In elke mail staat een afmeldlink. Wie zich afmeldde, krijgt hem nooit.",
  "mail_invitation_summary_line": "Niemand krijgt een code. | 1 persoon krijgt ‘{subject}’ met een eigen code. | {n} mensen krijgen ‘{subject}’, elk met een eigen code.",
  "mail_invitation_summary_no_recipients": "Er is nog niemand die deze uitnodiging kan krijgen. Kies bij Ontvangers wie je uitnodigt.",
  "mail_invitation_no_send_right": "Je kunt deze uitnodiging voorbereiden, maar versturen mag alleen iemand met het recht om mails te versturen.",
  "mail_invitation_cancel": "Uitnodiging annuleren",
  "mail_invitation_cancel_help": "Kan zolang er nog niks is verstuurd. De uitnodiging wordt dan weer een concept.",
  "mail_invitation_cancel_title": "Uitnodiging annuleren?",
  "mail_invitation_cancel_confirm": "Er gaat niks de deur uit en de uitnodiging wordt weer een concept, zodat je hem kunt aanpassen.",
  "mail_invitation_done": "Klaar, maar niemand heeft je uitnodiging gekregen. | Klaar: 1 persoon heeft je uitnodiging gekregen. | Klaar: {n} mensen hebben je uitnodiging gekregen.",
  "mail_invitation_held": "Wordt gecontroleerd",
  "mail_invitation_held_line": "We kijken even mee voordat je eigen lijst gemaild wordt. Daarna gaan de mails vanzelf de deur uit.",
  "mail_invitation_report_title": "Wie er komt",
  "mail_invitation_report_counts": "{mailed} gemaild · {bought} gekocht",
  "mail_invitation_bought": "Gekocht",
  "mail_invitation_export_unused": "Ongebruikte codes exporteren",
  "mail_invitation_remind": "Herinnering sturen",
  "mail_invitation_remind_help": "Niemand | Naar 1 persoon die nog niks kocht, met dezelfde code. | Naar {n} mensen die nog niks kochten, met dezelfde code.",
  "mail_invitation_remind_nobody": "Iedereen die hem kreeg heeft al gekocht.",
  "mail_invitation_remind_failed": "Herinnering maken lukte niet",
  "mail_campaign_error_mail_invitation_needs_discount": "De korting van deze uitnodiging staat uit of bestaat niet meer. Zet hem aan bij Kortingen.",
  "mail_campaign_error_mail_invitation_needs_confirmation": "Vink bij Ontvangers aan dat deze mensen dit van je verwachten.",
  "mail_campaign_error_mail_campaign_not_found": "Dit bericht bestaat niet meer. Ververs de pagina.",
  "mail_campaign_error_mail_campaign_not_invitation": "Dit kan alleen bij een uitnodiging.",
  "mail_campaign_error_mail_list_invalid": "Die lijst konden we niet lezen. Zet één adres per regel en probeer het nog eens.",
  "mail_campaign_error_mail_campaign_not_sent": "Een herinnering kan pas als de uitnodiging verstuurd is.",
  "mail_campaign_rail_content": "Wat wil je zeggen",
  "mail_campaign_rail_recipients": "Wie krijgt hem",
  "mail_campaign_rail_send": "Versturen",
  "mail_campaign_steps": "Stappen",
  "mail_campaign_step_done": "Klaar",
  "mail_campaign_next": "Volgende: {step}",
  "mail_campaign_to_send": "Verder naar versturen",
  "mail_campaign_content_title": "Wat wil je zeggen?",
  "mail_campaign_content_line": "Je mail staat al klaar in de stijl van je shop. Pas hem aan of stuur hem zo.",
  "mail_campaign_recipients_title": "Wie krijgt hem?",
  "mail_campaign_when_now": "zodra je verstuurt",
  "mail_campaign_when_at": "op {when}",
  "mail_campaign_postal_missing_title": "Je postadres ontbreekt.",
  "mail_campaign_postal_fill": "Adres invullen",
  "mail_campaign_postal_address": "Adres",
  "mail_campaign_postal_hint": "Staat onderaan elke nieuwsbrief, klein.",
  "mail_campaign_test_step": "1. Eerst een testmail",
  "mail_campaign_test_why": "Zo zie je hoe hij aankomt.",
  "mail_campaign_test_also_colleague": "Ook naar een collega",
  "mail_campaign_when_step": "2. Wanneer?",
  "mail_campaign_send": "Versturen",
  "mail_campaign_block_recipients": "Kies eerst wie hem krijgt.",
  "mail_campaign_block_postal": "Vul eerst je postadres in.",
  "mail_campaign_block_limit": "Je zit boven je grens aan contacten. Vraag hierboven een hogere grens aan.",
  "mail_campaign_block_when": "Kies een moment dat nog moet komen.",
  "mail_campaign_confirm_news_now_title": "Nieuwsbrief naar niemand sturen? | Nieuwsbrief naar 1 persoon sturen? | Nieuwsbrief naar {n} mensen sturen?",
  "mail_campaign_confirm_news_now": "Kan niet terug: zodra hij weg is, kun je hem niet meer terughalen of aanpassen.",
  "mail_campaign_confirm_news_later_title": "Nieuwsbrief inplannen voor {when}?",
  "mail_campaign_confirm_news_later": "Tot het zover is kun je het inplannen nog stoppen.",
  "mail_campaign_scheduled_line": "Gaat op {when} ({tz}) de deur uit. | Gaat op {when} ({tz}) naar 1 persoon. | Gaat op {when} ({tz}) naar {n} mensen.",
  "mail_campaign_tile_sent": "verstuurd",
  "mail_campaign_tile_arrived": "aangekomen",
  "mail_campaign_unschedule": "Inplanning stoppen",
  "mail_campaign_unscheduled": "Inplanning gestopt, het is weer een concept",
  "mail_campaign_copy_next": "Deze kopiëren voor de volgende",
  "mail_segment_group_label": "Wie krijgt hem",
  "mail_segment_group_everyone": "Iedereen met toestemming",
  "mail_segment_group_regulars": "Vaste bezoekers",
  "mail_segment_group_new_this_year": "Nieuw dit jaar",
  "mail_segment_group_not_seen_year": "Al een jaar niet gezien",
  "mail_segment_group_lapsed": "Vorig jaar wel, nu nog niet",
  "mail_segment_group_no_shows": "Wel gekocht, niet gekomen",
  "mail_segment_lapsed_came_pick": "Kies die van vorig jaar",
  "mail_segment_lapsed_not_pick": "Kies die van dit jaar",
  "mail_segment_count_people": "mensen met toestemming | persoon met toestemming | mensen met toestemming",
  "mail_segment_count_of_group": "van de {n} in deze groep",
  "mail_segment_narrow_label": "Kleiner maken:",
  "mail_segment_filter_event": "Kwam naar …",
  "mail_segment_filter_period": "Laatst geweest",
  "mail_segment_filter_tag": "Tag",
  "mail_segment_filter_clear": "Weghalen",
  "mail_segment_filter_remove": "{name} weghalen",
  "mail_campaign_summary_people": "niemand | 1 persoon | {n} mensen",
  "mail_campaign_summary_get": "krijgt | krijgt | krijgen",
  "mail_campaign_summary_no_mail_step": "Kies eerst een mail bij Wat wil je zeggen.",
  "mail_invitation_list_unsaved": "Sla de lijst eerst op.",
}
